module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av208-ee9d0eef5189a488d72776d29baf698e.jpg";